import React from 'react'
import { buildForceColorFullString } from '../utils/css'

export const itemClassName = 'categorySubItem'
export const iconClassName = 'categorySubItemIcon'

const CategorySubMenuStyle = ({ color }) => {
  const catColorString = buildForceColorFullString(color)
  const whiteColorString = buildForceColorFullString('white')

  return (
    <style>
      {`.${itemClassName}:hover{${catColorString}}`}
      {`.${iconClassName}{${catColorString}}`}
      {`.${itemClassName}:hover .${iconClassName}{${whiteColorString}background-color:${color};}`}
    </style>
  )
}

export default CategorySubMenuStyle
